// extracted by mini-css-extract-plugin
module.exports = {"description":"ConfirmContractTerminate_description__2HBUf"};